import Vue from 'vue'
import store from './store/store'
import router from './routes/router'
import vuetify from './plugins/vuetify';
import App from './App.vue'
import VueSocketIO from 'vue-socket.io'
import 'typeface-roboto/index.css';
import './assets/css/style.css'
import 'typeface-roboto/index.css';
import AsyncComputed from 'vue-async-computed'
Vue.use(AsyncComputed);
import VueHtml2pdf from 'vue-html2pdf'
Vue.use(VueHtml2pdf)
import VueCryptojs from 'vue-cryptojs'
Vue.use(VueCryptojs)
import VueNativeNotification from 'vue-native-notification'
import i18n from './plugins/i18n'

import VueTiles from 'vue-tiles'
import 'vue-tiles/dist/vue-tiles.css'
Vue.use(VueTiles)

import axios from "axios";
Vue.prototype.$http = axios
//import { createProvider } from './plugins/vue-apollo'

import VueApollo from 'vue-apollo';
import { apolloClient } from './mixin/apollo.js';
Vue.use(VueApollo)
const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
})


Vue.use(VueNativeNotification, {
    // Automatic permission request before
    // showing notification (default: true)
    requestOnNotify: true
})
Vue.config.productionTip = false


Vue.use(new VueSocketIO({
    debug: true,
    connection: 'https://tradeinpool.com:3011',

    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    },

}))


new Vue({
    apollo: {
        // Apollo specific options
      },

    vuetify,
    router,
    store,
    i18n,
    //apolloProvider: createProvider(),
    apolloProvider,
    render: h => h(App)
}).$mount('#app')